import React from "react"
import { ButtonLoadingSeeker } from "@ui-seeker/core"
import { isLoadingCommonFilters } from "@signals"
import { areCommonFiltersValid } from "@signals/commonFilters/filters"
import { Box } from "@mui/material"
import { batch } from '@preact/signals-react'
import { BISelectedOffice } from '../@signals'


export default function BIFiltersFooterActions() {

	return <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-around", gap: 1, my: 1 }}>
		<ButtonLoadingSeeker
			loading={isLoadingCommonFilters.value}
			sx={{ px: 4 }}
			onClick={() => batch(() => {
				BISelectedOffice.value = null
				isLoadingCommonFilters.value = true
			})}
			disabled={!areCommonFiltersValid.value}
		>
			Search
		</ButtonLoadingSeeker>
	</Box>
}